import { Component } from '@angular/core';

@Component({
  styles: [ require('./private.component.scss') ],
  template: require('./private.component.html')
})
export class PrivateComponent {}
